import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=df6bc466&scoped=true"
import script from "./shopDetails.vue?vue&type=script&lang=js"
export * from "./shopDetails.vue?vue&type=script&lang=js"
import style0 from "./shopDetails.vue?vue&type=style&index=0&id=df6bc466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6bc466",
  null
  
)

export default component.exports